import EventsBox from "components/company/v3/boxes/EventsBox";
import type { CompanyEventsTabEnum } from "components/company/v3/menu/enums";

interface FiisEventsBoxProps {
  tickerSymbol: string;
  isRenderPageDefault?: boolean;
  tab: CompanyEventsTabEnum;
  onChangeTab: (tab: CompanyEventsTabEnum) => void;
}

export default function FiisEventsBox({
  tickerSymbol,
  isRenderPageDefault = false,
  tab,
  onChangeTab,
}: FiisEventsBoxProps) {
  return (
    <EventsBox
      tickerSymbol={tickerSymbol}
      context="FIIS"
      isRenderPageDefault={isRenderPageDefault}
      tab={tab}
      onChangeTab={onChangeTab}
    />
  );
}
